import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const MAS_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.MAS,
  title: 'Scala Ashworth Modificata (MAS)',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: ['spalla', 'gomito', 'polso', 'anca', 'ginocchio', 'caviglia'],
  },
  sections: [
    {
      name: 'mas',
      label: 'Scala Ashworth Modificata (MAS)',
      fields: [
        {
          key: 'spalla',
          label: 'Spalla',
          type: 'number',
          step: 0.5,
          min: 0,
          max: 4,
          maxScore: 4,
          allowedValues: [0, 1, 1.5, 2, 3, 4],
          valueDescriptions: {
            '0': 'Nessun aumento del tono muscolare.',
            '1': 'Lieve aumento del tono (fine o inizio ROM).',
            '1.5': 'Lieve aumento con resistenza minima (equivale a 1+).',
            '2': "Aumento marcato del tono in gran parte dell'arco.",
            '3': 'Aumento considerevole: movimento passivo difficile.',
            '4': 'Parte interessata rigida in flessione o estensione.',
          },
          description: 'Valutazione della spasticità alla spalla.',
        },
        {
          key: 'gomito',
          label: 'Gomito',
          type: 'number',
          step: 0.5,
          min: 0,
          max: 4,
          maxScore: 4,
          allowedValues: [0, 1, 1.5, 2, 3, 4],
          valueDescriptions: {
            '0': 'Nessun aumento del tono.',
            '1': 'Lieve aumento del tono.',
            '1.5': 'Resistenza minima al ROM (1+).',
            '2': 'Aumento marcato del tono.',
            '3': 'Movimento passivo difficile.',
            '4': 'Rigidità completa.',
          },
          description: 'Valutazione della spasticità al gomito.',
        },
        {
          key: 'polso',
          label: 'Polso',
          type: 'number',
          step: 0.5,
          min: 0,
          max: 4,
          maxScore: 4,
          allowedValues: [0, 1, 1.5, 2, 3, 4],
          valueDescriptions: {
            '0': 'Normale.',
            '1': 'Leggera resistenza.',
            '1.5': 'Resistenza minima (1+).',
            '2': 'Aumento marcato.',
            '3': 'Movimento passivo difficoltoso.',
            '4': 'Rigidità.',
          },
          description: 'Valutazione della spasticità al polso.',
        },
        {
          key: 'anca',
          label: 'Anca',
          type: 'number',
          step: 0.5,
          min: 0,
          max: 4,
          maxScore: 4,
          allowedValues: [0, 1, 1.5, 2, 3, 4],
          valueDescriptions: {
            '0': 'Normale.',
            '1': 'Lieve aumento.',
            '1.5': 'Resistenza minima (1+).',
            '2': 'Aumento marcato.',
            '3': 'Movimento difficile.',
            '4': 'Rigidità.',
          },
          description: "Valutazione della spasticità all'anca.",
        },
        {
          key: 'ginocchio',
          label: 'Ginocchio',
          type: 'number',
          step: 0.5,
          min: 0,
          max: 4,
          maxScore: 4,
          allowedValues: [0, 1, 1.5, 2, 3, 4],
          valueDescriptions: {
            '0': 'Nessuna alterazione.',
            '1': 'Lieve resistenza.',
            '1.5': 'Resistenza minima (1+).',
            '2': 'Tono aumentato.',
            '3': 'Movimento passivo difficile.',
            '4': 'Rigidità.',
          },
          description: 'Valutazione della spasticità al ginocchio.',
        },
        {
          key: 'caviglia',
          label: 'Caviglia',
          type: 'number',
          step: 0.5,
          min: 0,
          max: 4,
          maxScore: 4,
          allowedValues: [0, 1, 1.5, 2, 3, 4],
          valueDescriptions: {
            '0': 'Normale.',
            '1': 'Lieve aumento.',
            '1.5': 'Aumento minimo (1+).',
            '2': 'Aumento marcato.',
            '3': 'Movimento passivo problematico.',
            '4': 'Rigidità completa.',
          },
          description: 'Valutazione della spasticità alla caviglia.',
        },
      ],
    },
  ],

  computedFields: [
    {
      key: 'riepilogo',
      label: 'Riepilogo Valutazione MAS',
      type: 'list',
      calculation: '',
      maxScore: 0,
    },
  ],
};
